module.exports = {
	siteName: 'myaccount',
	site: {
		mancity: {},
	},
};
